import { BrowserRouter, Routes, Route } from "react-router-dom";
import EventsMap from "./pages/EventsMap";
import CookieBanner from "./components/CookieBanner";

function App() {
  return (
    <div className="min-h-screen aurora-bg text-slate-900">
      <BrowserRouter>
        <main className="h-screen">
          <Routes>
            <Route path="/" element={<EventsMap />} />
          </Routes>
        </main>
        <CookieBanner />
      </BrowserRouter>
    </div>
  );
}

export default App;
